import { makeAutoObservable } from 'mobx'

type IEnrollByWebhookStoreParams = { isActive: boolean; webhook_url?: string }

export class EnrollByWebhookStore {
  constructor(params?: IEnrollByWebhookStoreParams) {
    if (params) {
      this.init(params)
    }
    makeAutoObservable(this)
  }

  init = ({ isActive, webhook_url }: IEnrollByWebhookStoreParams) => {
    this._isActive = isActive
    this._webhookUrl = webhook_url || null
  }

  private _isActive = false
  get isActive() {
    return this._isActive
  }
  setActive = async (value: boolean) => {
    this._isActive = value
  }
  private _webhookUrl: string | null = null
  get webhookUrl() {
    return this._webhookUrl
  }
  setWebhookUrl = (value: string) => {
    this._webhookUrl = value
  }
}
